<template>
    <div>
        <h1 class="title has-text-centered">Mes rendez-vous OKKKK</h1>
        <section class="section">
            <div class="tabs is-centered" id='rdvs-tab'>
                <ul>
                    <li class="is-active" @click="switchRdvs('past', '#rdvs-past')" id='rdvs-past'>
                        <a href="#">
                            <span>Passés ({{rdvsFinished.length}})</span>
                        </a>
                    </li>
                    <li @click="switchRdvs('to-come', '#rdvs-to-come')" id='rdvs-to-come'>
                        <a href="#">
                            <span>A venir ({{rdvsToCome.length}})</span>
                        </a>
                    </li>
                </ul>
            </div>
            <section class="section px-0" v-if="rdvsToPrint === 'past'">
                <article class="message is-info is-large" v-if="rdvsFinished.length === 0">
                    <div class="message-body">                    
                        Vous n'avez pas encore pris de rendez-vous.
                        Cliquez sur le bouton 'Prendre un rendez-vous'.
                    </div>
                </article>
                <div class="card mb-5" v-for="(rdv, index) in rdvsFinished" :key="index">
                    <div class="card-header">
                        <div class="card-header-title is-info has-text-centered">
                            {{formatDate(rdv.start_date)}}
                        </div>
                    </div>

                    <div class="card-content">

                        <div class="content">
                            <div class="columns is-multiline">
                                <div class="column is-half"><b>Prestation{{rdv.prestations?.length > 1 ? 's':''}}&nbsp;:</b> {{rdv.prestations_list}}</div>
                                <div class="column is-half"><b>Statut&nbsp;:</b> {{rdv.status}}</div>
                                <div class="column is-half"><b>Lieu&nbsp;:</b> {{rdv.location?.name || 'Non precisé'}}</div>
                                <div class="column is-half"><b>Avec&nbsp;:</b> {{rdv.agenda?.name || 'Non precisé'}}</div>
                                <div class="column is-half" v-if="config.display_duration"><b>Durée du rendez-vous&nbsp;:</b> {{rdv.duration}}</div>
                                <div class="column is-half" v-if="config.display_price"><b>Prix&nbsp;:</b> {{rdv.price}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section class="section px-0" v-if="rdvsToPrint === 'to-come'">
                <article class="message is-info is-large" v-if="rdvsToCome.length === 0">
                    <div class="message-body">
                        Vous n'avez pas de rendez-vous programmé.
                        Cliquez sur le bouton 'Prendre un rendez-vous'.
                    </div>
                </article>
                <div class="card mb-5" v-for="(rdv, index) in rdvsToCome" :key="index">
                    <div class="card-header">
                        <div class="card-header-title is-info has-text-centered">
                            {{formatDate(rdv.start_date)}}
                        </div>
                    </div>
                    <div class="card-content">
                        <div class="content">
                            <div class="columns is-multiline">
                                <div class="column is-half"><b>Prestation{{rdv.prestations?.length > 1 ? 's':''}}&nbsp;:</b> {{rdv.prestations_list}}</div>
                                <div class="column is-half"><b>Lieu&nbsp;:</b> {{rdv.location?.name || rdv.agenda.location.name || ''}}</div>
                                <div class="column is-half"><b>Adresse&nbsp;:</b> {{rdv.location?.address || rdv.agenda.location.address}}</div>
                                <div class="column is-half"><b>Avec&nbsp;:</b> {{rdv.agenda.internet_name || rdv.agenda.name}}</div>
                                <div class="column is-half" v-if="config.display_duration"><b>Durée du rendez-vous&nbsp;:</b> {{getDuration(rdv)}}</div>
                                <div class="column is-half" v-if="config.display_price"><b>Prix&nbsp;:</b> {{getPrice(rdv)}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer">
                        <div class="card-footer-item">
                            <button class="button is-flex-grow-1 footer-button edit" v-if="canCancelRdv(rdv) && fo_config['redirected'] != 1" @click="onModify(rdv)">
                                <span class="mr-2">
                                    <i class="fas fa-pencil-alt"></i> 
                                </span>
                                Modifier le rendez-vous.
                            </button>
                        </div>
                        <div class="card-footer-item" v-if="canCancelRdv(rdv) && fo_config['redirected'] != 1" @click="showCancelRdv(rdv)">
                            <button class="button is-flex-grow-1 footer-button cancel">
                                <span class="mr-2">
                                    <i class="fas fa-trash-alt"></i> 
                                </span>
                                Annuler le rendez-vous.
                            </button>
                        </div>
                    </div>
                </div>
            </section>
        </section>
        <div class="modal" id="cancel-rdv-modal">
            <div class="modal-background"></div>
            <div class="modal-card">
                <header class="modal-card-head">
                <p class="modal-card-title">Confirmation d'annulation de rendez-vous</p>
                <button class="delete" @click="hideCancelRdv()" aria-label="close"></button>
                </header>
                <section class="modal-card-body">
                    <p>Etes vous certain de vouloir annuler ce rendez-vous ?</p>
                    <div class="buttons is-justify-content-flex-end pt-3">
                        <button class="button is-info" @click="cancelRdv">Confirmer</button>
                        <button class="button" @click="hideCancelRdv()">Annuler</button>
                    </div>
                </section>

            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import moment from'moment'
import {toast} from 'bulma-toast'
export default {
    name: 'MesRendezVous',
    props: ['fo_config'],
    data () {
        return {
            rdvsFinished: [],
            rdvToCancel: null,
            rdvsToCome: [],
            rdvsToPrint: 'past'
        }
    },
    computed: {
        config () {
            console.log('page props config', this.$page.props.config)
            return this.$page.props.config
        },
        user() {
            return this.$page.props.auth.user?.client?.[0]
        },
        redirected(){
            return this.fo_config && (this.fo_config['redirected'] == 1);
        },
        redirect_params(){
            if(!this.redirected){
                return '';
            }
            let url = window.location.href;
            // let params = url.substring(url.lastIndexOf('/')+1).replace('times','');
            let params = url.split('?',2)[1];
            return params+'&redirected=1';     
        }        
    },
    methods: {
        can_modify(rdv){

        },
        can_cancel(rdv){
            if (!this.config.allow_client_delete_rdv) return false;
            return this.config['']
        },
        canCancelRdv(rdv) {
            if (!this.config.allow_client_delete_rdv) return false
            if (!this.config.last_annulation_time) return true
            let date_rdv = moment().add(this.config.last_annulation_time, 'hours')
            return date_rdv.isBefore(moment(rdv.start_date).format('YYYY-MM-DD HH:mm:ss'))
        },
        time_is_valid(rdv) { // date non expiré
            if (!this.config.last_annulation_time) return true
            let date_rdv = moment().add(this.config.last_annulation_time, 'hours')
            return date_rdv.isBefore(moment(rdv.start_date).format('YYYY-MM-DD HH:mm:ss'))
        },
        cancelRdv() {
            if (!this.rdvToCancel) return false
            axios.delete('/rdv/'+ this.rdvToCancel).then(response => {
                this.rdvsToCome = this.rdvsToCome.filter(rdv => rdv.rdv_id != this.rdvToCancel)
                toast({
                    message: 'Votre rendez-vous a bien été annulé.',
                    type: 'is-success',
                    duration: 3000,
                    pauseOnHover: true
                })
                this.hideCancelRdv()
            }).catch(err => {
                toast({
                    message: err?.response?.data?.message || 'Une erreur a empeché la suppression du rendez-vous.',
                    type: 'is-danger',
                    duration: 5000,
                    pauseOnHover: true
                })
                this.hideCancelRdv()
            })
        },
        formatDate (d) {
            if (!d) return ''
            return 'Le ' + moment(d).locale('fr').format('dddd DD MMMM YYYY à HH:mm')
        },
        getDuration(rdv) {
            if (!rdv.prestation.display_duration || rdv.prestations.find(prestation => !prestation.display_duration)) return 'Durée non communiquée'
            let duration = rdv.prestations.reduce((accumulator, prestation) => accumulator += prestation.duration, 0)
            let hours = Math.floor(duration / 60)
            let minutes = duration % 60
            if (minutes < 10 && minutes != 0) minutes = '0' + minutes
            let str = ''
            if (hours) str += hours + 'h'
            if (minutes) str += minutes + ' min.'
            return str
        },
        getPrestations(rdv) {
            return rdv.prestations.map(prestation => prestation.fo_name || prestation.bo_name).join(', ')
        },
        getPrice (rdv) {
            if (!rdv.prestation.display_price || rdv.prestations.find(prestation => !prestation.display_price)) return 'Non communiqué'
            return rdv.prestations.reduce((accumulator, prestation) => accumulator += prestation.price ?? 0, 0) + this.config.money
        },
        getRdvs () {
            axios.get('client/rdvs').then(response => {
                this.rdvsFinished = response.data.rdvsPasse.map(rdv => {
                    rdv.prestations = [rdv.prestation, ...rdv.prestations_sup]
                    rdv.status = this.getStatus(rdv)
                    rdv.duration = this.getDuration(rdv)
                    rdv.prestations_list = this.getPrestations(rdv)
                    rdv.price = this.getPrice(rdv)
                    if (rdv.location == null){
                        rdv.location = rdv?.agenda?.location
                    }
                    return rdv
                }).sort((a, b) => (new Date(a.start_date).getTime() < new Date(b.start_date).getTime()))
                this.rdvsToCome = response.data.rdvsVenir.map(rdv => {
                    rdv.prestations = [rdv.prestation, ...rdv.prestations_sup]
                    rdv.prestations_list = this.getPrestations(rdv)
                    return rdv
                }).sort((a, b) => (new Date(a.start_date).getTime() > new Date(b.start_date).getTime()))
            })
        },
        getStatus (rdv) {
            if (rdv.state == 0) return 'En attente'
            else if (rdv.state == 1) return 'Venu'
            else if (rdv.state == -1) return 'Pas venu'
            else return ''
        },
        hideCancelRdv () {
            let modal = document.querySelector('#cancel-rdv-modal')
            modal.classList.remove('is-active')
            this.rdvToCancel = null
        },
        showCancelRdv(rdv) {
            let modal = document.querySelector('#cancel-rdv-modal')
            modal.classList.add('is-active')
            this.rdvToCancel = rdv.rdv_id
        },
        switchRdvs (status, tab) {
            let ul = document.querySelector('#rdvs-tab > ul')
            for (let li of ul.children) {
                li.classList.remove('is-active')
            }
            document.querySelector(tab).classList.add('is-active')
            this.rdvsToPrint = status
        },
        onModify(rdv){
            console.log('on modify',this.fo_config,rdv);
            
            if(this.redirected){
                console.log("dans la redirection",'/redirect/times'+this.redirect_params+"&rdv_id="+rdv.rdv_id);
                
                this.$inertia.get('/redirect/times?rdv_id='+rdv.rdv_id+'&'+this.redirect_params+"&rdv_id="+rdv.rdv_id);
                return null;
            }
            // let group_size = 
            console.log("after redirection");
            
            this.$inertia.get("/times?price="+rdv.presta_price+"&prestation_id="+rdv.prestation_id+"&location_id="+rdv?.location?.location_id+"&agenda_id="+rdv.agenda_id+"&rdv_id="+rdv.rdv_id+"&group_size="+this.getGroupSizeFromRdv(rdv));
        },
        getGroupSizeFromRdv(rdv){
            if(!rdv.prestation || rdv.prestation.is_group == 0 || !rdv.participants || rdv.participants.length < 1){
                return 1;
            }
            
            for (const participant of rdv.participants) {
                if (participant.client_id == this.user.client_id) {
                    let attendees = JSON.parse(participant.attendees ?? '[]') ?? [];
                    return attendees.length + 1;
                }
            }

            return 1;
        }
    },
    mounted () {
        console.log('page props config', this.$page.props.config)
        this.getRdvs();
        document.querySelector('#rdvs-to-come').click();
    }

}
</script>

<style scoped>
    .card-footer-item:hover {
        background-color: #fafafa;
    }
    .is-flex-grow-1.footer-button {
        background-color: inherit;
        border: 0;
        outline: none;
    }
    .footer-button.edit {
        color: #3e8ed0;
    }
    .footer-button.cancel {
        color: red;
    }
</style>